export default __webpack_public_path__ + "static/media/9_2.e9a3bdec.jpg";